import React from 'react'

const ViewBanner = () => {
  return (
    <div>ViewBanner</div>
  )
}

export default ViewBanner